// Generated types for CatalogNode
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { IslandRootReadAPI, IslandRootWriteAPI } from './islandroot';
import { IslandRootReadAPISchemaObject, IslandRootWriteAPISchemaObject } from './islandroot';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface CatalogNodeReadAPI extends IslandRootReadAPI {
  /** Derived unique identity '{scope_id}:{slug}' (67 §10b). canonical_only: carries a uniqueness constraint, so twins/shadows must never copy it (cow reads this marker). */
  scoped_slug_key?: string | null;
  /** Retired: kept for the islands that use it, never used anew — a new link or reference to it is refused. */
  retired?: boolean;
}

export interface CatalogNodeWriteAPI extends IslandRootWriteAPI {
  /** Retired: kept for the islands that use it, never used anew — a new link or reference to it is refused. */
  retired?: boolean;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const CatalogNodeReadAPISchemaObject = IslandRootReadAPISchemaObject.extend({
  scoped_slug_key: z.string().nullable().optional(),
  retired: z.boolean().optional(),
}).passthrough();
export const CatalogNodeReadAPISchema: z.ZodType<CatalogNodeReadAPI> = CatalogNodeReadAPISchemaObject;

export const CatalogNodeWriteAPISchemaObject = IslandRootWriteAPISchemaObject.extend({
  retired: z.boolean().optional(),
}).passthrough();
export const CatalogNodeWriteAPISchema: z.ZodType<CatalogNodeWriteAPI> = CatalogNodeWriteAPISchemaObject;
